<template lang="pug">
  Layout
    v-overlay(:value="isLoading")
      v-progress-circular(:value="20" indeterminate)
    v-container.media.py-0(fluid)
      v-row(style="min-height:200px")
        v-col(md="3", sm="4", xs="12")
          FormWrapper.fill-height(
            type="media",
            no-spacing,
          )
            template( v-slot:default="props")
              MediaForm.fill-height(
                :enable-scanner="true",
                :model="props.model",
                :validate="props.validate",
                :valid="props.valid",
                :reset="props.reset",
                @updated="fetchMedia(); flushSelections();",
                :media="selections[0]",
              )
                template(v-slot="{ open }")
                  v-card.media-item.add-box(
                    @click="open(true)",
                  )
                    v-icon(color="primary") fas fa-cloud-upload-alt
                  v-card(
                    ref="uploadBtn",
                    v-show="false",
                    @click="open(false)",
                  )
        v-col(
          v-for="media in medias", :key="media.id",
          md="3", sm="4", xs="12",
        )
          v-card.media_item(:class="{ 'media_video': media.is_video }")
            Projector(
              show-mask,
              :active="exist(media.id)",
              :media="media",
              @preview="previewMedia(media)",
            )
      Previewer(
        v-if="previewer",
        :selections="selections",
        :value.sync="previewer",
      )
      Controller(
        :selections="selections",
        @download="download",
        @preview="previewer = true",
        @remove="previewMedia",
        @delete="remove",
        @edit="$refs.uploadBtn.click()",
      )

</template>

<script>
import { mapGetters } from 'vuex';
import { clone } from 'ramda';
import { progressWrapper } from '@/config/mixins.js';

import Controller from '@/components/Media/Controller.vue';
import FormWrapper from '@/components/wrapper/FormWrapper.vue';
import Layout from '@/layouts/User.vue';
import MediaForm from '@/components/forms/Media.vue';
import Previewer from '@/components/Media/Previewer.vue';
import Projector from '@/components/Media/Projector.vue';

export default {
  mixins: [progressWrapper],

  components: {
    Controller,
    FormWrapper,
    Layout,
    MediaForm,
    Previewer,
    Projector,
  },

  data() {
    return {
      previewer: false,
      selections: [],
    };
  },

  computed: {
    ...mapGetters({
      user: 'user/user',
      medias: 'media/items',
    }),
  },

  methods: {
    previewMedia(media) {
      if (this.exist(media.id)) {
        this.selections = this.selections.filter(x => x.id !== media.id);
      } else if (this.selections.length === 4) {
        this.selections.push(clone(media));
        this.selections.shift();
      } else {
        this.selections.push(clone(media));
      }
    },

    flushSelections() {
      this.selections = [];
    },

    download({ id }) {
      this.$store.dispatch('media/download', id);
    },

    exist(id) {
      return this.selections.find(x => x.id === id) !== undefined;
    },

    remove(id) {
      this.wrapProgress(() =>
        this.$store.dispatch('media/remove', id).then(() => {
          this.selections = [];
          this.fetchMedia();
        }),
      );
    },

    fetchMedia() {
      this.$store.dispatch('media/fetch', {
        user_id: this.$route.params.id,
        limit: 1000,
        skip: 0,
      });
    },
  },
};
</script>
